import { computed, PropType, defineComponent } from 'vue';
import renderFn from '../utils/render-fn';
import {
  TdIconSVGProps, SVGJson,
} from '../utils/types';
import useSizeProps from '../utils/use-size-props';

import '../style/css';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"currentColor","d":"M12.0001 0.845337L21.6604 6.42269V17.5774L12.0001 23.1547L2.33984 17.5774V6.42269L12.0001 0.845337ZM12.0001 3.15474L4.33984 7.57739V16.4227L12.0001 20.8453L19.6604 16.4227V7.57739L12.0001 3.15474ZM12.0001 9.00004C10.3432 9.00004 9.0001 10.3432 9.0001 12C9.0001 13.6569 10.3432 15 12.0001 15C13.657 15 15.0001 13.6569 15.0001 12C15.0001 10.3432 13.657 9.00004 12.0001 9.00004ZM7.0001 12C7.0001 9.23861 9.23867 7.00004 12.0001 7.00004C14.7615 7.00004 17.0001 9.23861 17.0001 12C17.0001 14.7615 14.7615 17 12.0001 17C9.23867 17 7.0001 14.7615 7.0001 12Z"}}]};

export default defineComponent({
  name: 'SettingIcon',
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<TdIconSVGProps['onClick']>,
    },
  },
  setup(props, { attrs }) {
    const propsSize = computed(() => props.size);

    const { className, style } = useSizeProps(propsSize);

    const finalCls = computed(() => ['t-icon', 't-icon-setting', className.value]);
    const finalStyle = computed(() => ({ ...style.value, ...(attrs.style as Styles) }));
    const finalProps = computed(() => ({
      class: finalCls.value,
      style: finalStyle.value,
      onClick: (e:MouseEvent) => props.onClick?.({ e }),
    }));
    return () => renderFn(element, finalProps.value);
  },

});
